import EnrollDrillTeam from '../components/EnrollDrillTeam';
import DrillTeamSubmission from '../components/DrillTeamSubmission';
import { useState } from 'react';

const DrillTeam = () => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(9);
  return (
    <div className='flex bg-[#F9FAFB] relative'>
      <EnrollDrillTeam setSubmissionPage={setPage} submissionPage={page} submissionPerPage={perPage} />
      <DrillTeamSubmission page={page} setPage={setPage} setPerPage={setPerPage} perPage={perPage} />
    </div>
  );
};

export default DrillTeam;
